import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiCall from "../utils/apiCall";
import { toastFire } from "../utils/toastFire";

export const fetchVendors = createAsyncThunk(
  "vendorsSlice/fetchVendors",
  async (_, { getState, ...thunkApi }) => {
    const { token } = getState().auth;
    return await apiCall(
      `/vendors`,
      {
        headers: {
          Authorization: token,
        },
      },
      thunkApi,
    );
  },
);

export const addVendor = createAsyncThunk(
  "vendorsSlice/addVendor",
  async (vendor, { getState, ...thunkApi }) => {
    const { token } = getState().auth;

    return await apiCall(
      `/vendors`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(vendor),
      },
      thunkApi,
    );
  },
);

export const deleteVendor = createAsyncThunk(
  "vendorsSlice/deleteVendor",
  async (vendorId, { getState, ...thunkApi }) => {
    const { token } = getState().auth;
    await apiCall(
      `/vendors/${vendorId}`,
      {
        method: "DELETE",
        headers: {
          Authorization: token,
        },
      },
      thunkApi,
    );
    return vendorId;
  },
);

export const editVendor = createAsyncThunk(
  "vendorsSlice/editVendor",
  async (vendor, { getState, ...thunkApi }) => {
    const { token } = getState().auth;
    return await apiCall(
      `/vendors/${vendor._id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(vendor),
      },
      thunkApi,
    );
  },
);

const vendorsSlice = createSlice({
  name: "vendorsSlice",
  initialState: {
    loading: false,
    error: null,
    data: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchVendors.pending, (state, action) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVendors.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchVendors.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(addVendor.fulfilled, (state, action) => {
        state.data.unshift(action.payload);
        toastFire("success", `تم اضافة ${action.payload.name} بنجاح`);
      })
      .addCase(deleteVendor.fulfilled, (state, action) => {
        state.data = state.data.filter(
          (vendor) => vendor._id !== action.payload,
        );
        toastFire("success", `تم حذف المورد بنجاح`);
      })
      .addCase(editVendor.fulfilled, (state, action) => {
        const index = state.data.findIndex(
          (vendor) => vendor._id === action.payload._id,
        );
        if (index !== -1) {
          state.data[index] = action.payload;
        }
        toastFire("success", `تم تعديل ${action.payload.name} بنجاح`);
      });
  },
});

export default vendorsSlice.reducer;
